import { system } from '../../../system'

export const InputAddon = system('div')({
  display: 'flex',
  flex: 0,
  justifyContent: 'center',
  alignItems: 'center'
})
